module.exports = __webpack_public_path__ + "media/images/web/home/index/customizable-7f3b8c537887e1e977ce402c59b215f4.webp";